<div tabindex="0" pRipple (click)="overlayPanel.toggle($event)" class="overlay-toggler">
  <i class="text-color" [ngClass]="IconKey.TopbarAttentionIndicator | icon"></i>
  @if ($attentionEquipmentsTotalAmount()) {
    <osp-badge
      class="overlay-toggler__badge"
      badgeSeverity="danger"
      [value]="$attentionEquipmentsTotalAmount()"
    ></osp-badge>
  }
</div>

<osp-overlay-panel #op [showFooter]="false">
  <div header>
    <h3>{{ 'modules.navigation.sidebar.attentionEquipments' | translate }}</h3>
  </div>

  <div body>
    @if ($isListLoading()) {
      <div class="loading-spinner-container">
        <osp-spinner />
        <p class="text-color font-bold m-0">
          {{ 'general.loading.title' | translate }}
        </p>
      </div>
    } @else {
      @if ($attentionEquipmentsTotalAmount()! > 0) {
        <div class="flex flex-column w-full">
          @for (attentionEquipment of $attentionEquipments(); track attentionEquipment.equipmentId) {
            <div (click)="onItemClick(attentionEquipment)">
              <div class="attention-equipment">
                <div class="attention-equipment__left-column">
                  <osp-dynamic-thumbnail
                    [thumbnailKey]="attentionEquipment.thumbnailKey"
                    [thumbnailLetter]="attentionEquipment.equipmentName?.charAt(0)"
                    class="thumbnail"
                  />
                  <div class="attention-equipment__info">
                    <p class="text-sm text-color font-bold m-0">{{ attentionEquipment.equipmentName }}</p>
                    @if (attentionEquipment.currentAddress | address; as equipmentAddress) {
                      <p class="text-sm text-color m-0">{{ equipmentAddress }}</p>
                    }
                  </div>
                </div>
                <div class="attention-equipment__tag">
                  <osp-attention-status-tag
                    [size]="ComponentSize.SMALL"
                    [status]="attentionEquipment.attentionStatus"
                  />
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="attention-equipment">
          <p class="text-sm text-color m-0">
            {{ 'revolution.modules.attentionStatus.noAttentionEquipmentFound' | translate }}
          </p>
        </div>
      }
    }
  </div>
</osp-overlay-panel>
